const AdminUserListing = () => import('@/components/admin/user/Listing')
const AdminUserUpgrade = () => import('@/components/admin/user/Upgrade')
const AdminUserFormNew = () => import('@/components/admin/user/FormNew')
const AdminUserDisplay = () => import('@/components/admin/user/Display/Index')
const AdminUserEdit = () => import('@/components/admin/user/Edit')

export default [
  {
    path: '/admin/users/',
    name: 'users.listing',
    components: {
      admin: AdminUserListing
    }
  },
  {
    path: '/admin/users/upgrade',
    name: 'users.upgrade',
    components: {
      admin: AdminUserUpgrade
    }
  },
  {
    path: '/admin/users/create',
    name: 'users.form',
    components: {
      admin: AdminUserFormNew
    }
  },
  {
    path: '/admin/users/edit/:id',
    name: 'users.edit',
    components: {
      admin: AdminUserEdit
    }
  },
  {
    path: '/admin/users/display/:id',
    name: 'users.display',
    components: {
      admin: AdminUserDisplay
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin.js